import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import NoRouteFound from './components/elements/NoRouteFound';
import Login from './pages/auth/login';
import Categories from './pages/dashboard/categories';
import HomePage2 from './pages/dashboard/home';
import Products from './pages/dashboard/products';
import Users from './pages/dashboard/users';
import ProductDetails from './pages/dashboard/products/product-details';
import UnauthorizedPage from './pages/unauthorized';
import ResetPasswordPage from './pages/reset-password';
import ForgotPasswordPage from './pages/forgot-password';
import Registry from './pages/registry';
import AutosuggestionProducts from './pages/dashboard/autosuggestProducts';
import Logs from './pages/logs-management';
import AffiliateTags from './pages/dashboard/affiliate-tags';
import AISurvey from './pages/dashboard/aiSurvey';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/login" element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route path='/reset-password' element={<ResetPasswordPage />} />
        <Route path="/registry/:registryUrl" element={<Registry />} />
        <Route path="*" exact element={<NoRouteFound />} />
        <Route element={<PrivateRoutes />}>
          <Route path="*" exact element={<NoRouteFound />} />
          <Route index element={<HomePage2 />} />
          <Route path="/dashboard" element={<HomePage2 />} />
          <Route path="/users" element={<Users />} />
          <Route path="/products" element={<Products />} />
          <Route path="/autosuggest" element={<AutosuggestionProducts />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/affiliate-tags" element={<AffiliateTags />} />
          <Route path='/aisurvey' element={<AISurvey/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
